"use strict";
export function UngroupedGroupCreator(documents) {
  return {
    groups: [
      {
        documents,
        name: "Ungrouped Documents",
        selected: true
      }
    ],
    groupSelected: () => {
    }
  };
}
